import styled from "@emotion/styled"

import { $Panel } from "../../shared-overlays/styles/$Panel"

export const $FileDialog = styled($Panel)`
  padding: 1em;
  width: 18em;
`
